export function findFeedbackById(id) {
  const data = JSON.parse(sessionStorage.getItem("subData"));

  let output = {};

  output = data.find((item) => {
    if (item._id == id) return true;
  });
  let arr = [];
  if (output) {
    arr.push(output);
    return arr;
  } else return null;
}
